var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    {
      staticClass: "sharing-panel-item",
      class: { "sharing-panel-item_active": _vm.item.active },
      staticStyle: { "text-decoration": "none" },
      attrs: {
        to: { ..._vm.$route, name: _vm.item.to },
        "aria-label": _vm.item.label,
      },
    },
    [
      _c(
        "div",
        { staticClass: "sharing-panel-item__icon", class: _vm.item.iconClass },
        [
          _c("span", { staticClass: "sharing-panel-item__icon-counter" }, [
            _vm._v(_vm._s(_vm.item.count)),
          ]),
          _vm._v(" "),
          _vm.item.hasNew
            ? _c(
                "span",
                { staticClass: "sharing-panel-item__icon-new-marker" },
                [_vm._v("NEW")]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "sharing-panel-item__text" }, [
        _vm._v("\n        " + _vm._s(_vm.item.label) + "\n    "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }